"use strict";
/**
 * Form Utilities
 * Handles form population and value extraction
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.populateSettingsForm = populateSettingsForm;
exports.getSettingsFormValues = getSettingsFormValues;
exports.getCredentialsFormValues = getCredentialsFormValues;
exports.populateCredentialsForm = populateCredentialsForm;
const permissions_1 = require("../permissions");
/**
 * Populate settings form with current values
 */
function populateSettingsForm(settings) {
    const form = document.getElementById("settings-form");
    if (!form)
        return;
    document.getElementById("shares").value =
        settings.shares.toString();
    document.getElementById("dollar-amount").value =
        settings.dollarAmount.toString();
    document.getElementById("timeout").value =
        settings.orderTimeoutSeconds.toString();
    document.getElementById("slippage-slider").value =
        settings.slippageTolerancePercent.toString();
    // Independent slippage sliders
    const sliderA = document.getElementById("slippage-slider-a");
    const sliderB = document.getElementById("slippage-slider-b");
    if (sliderA) {
        sliderA.value = (settings.slippageTolerancePercentA ??
            settings.slippageTolerancePercent).toString();
    }
    if (sliderB) {
        sliderB.value = (settings.slippageTolerancePercentB ??
            settings.slippageTolerancePercent).toString();
    }
    const manualToggle = document.getElementById("manual-price-toggle");
    if (manualToggle) {
        manualToggle.checked = settings.manualPriceMode === true;
    }
    const sellModeToggle = document.getElementById("sell-mode-toggle");
    const fixedSellGroup = document.getElementById("fixed-sell-quantity-group");
    const fixedSellInput = document.getElementById("fixed-sell-quantity");
    if (sellModeToggle) {
        const isPartial = settings.sellMode === "partial";
        sellModeToggle.checked = isPartial;
        if (fixedSellGroup) {
            fixedSellGroup.classList.toggle("hidden", !isPartial);
        }
    }
    if (fixedSellInput) {
        fixedSellInput.value = (settings.fixedSellQuantity ?? 1).toString();
    }
    const forceDefaultToggle = document.getElementById("force-default-buttons-toggle");
    if (forceDefaultToggle) {
        forceDefaultToggle.checked = settings.forceDefaultButtons === true;
    }
}
/**
 * Get values from settings form
 */
function getSettingsFormValues() {
    const manualToggle = document.getElementById("manual-price-toggle");
    const sellModeToggle = document.getElementById("sell-mode-toggle");
    const fixedSellInput = document.getElementById("fixed-sell-quantity");
    const rawFixedQty = fixedSellInput
        ? parseInt(fixedSellInput.value, 10)
        : 1;
    const fixedSellQuantity = Number.isFinite(rawFixedQty) && rawFixedQty > 0 ? rawFixedQty : 1;
    const forceDefaultToggle = document.getElementById("force-default-buttons-toggle");
    return {
        shares: parseInt(document.getElementById("shares").value, 10),
        // Clamp to the tier's per-order cap (server enforces regardless).
        dollarAmount: (0, permissions_1.clampBetToCap)(parseFloat(document.getElementById("dollar-amount")
            .value)),
        orderTimeoutSeconds: parseInt(document.getElementById("timeout").value, 10),
        slippageTolerancePercent: parseFloat(document.getElementById("slippage-slider")
            .value),
        independentSlippage: (() => {
            const container = document.getElementById("independent-slippage-container");
            return container
                ? !container.classList.contains("hidden")
                : false;
        })(),
        slippageTolerancePercentA: parseFloat(document.getElementById("slippage-slider-a")?.value ?? "3"),
        slippageTolerancePercentB: parseFloat(document.getElementById("slippage-slider-b")?.value ?? "3"),
        manualPriceMode: manualToggle ? manualToggle.checked : false,
        sellMode: sellModeToggle && sellModeToggle.checked ? "partial" : "full",
        fixedSellQuantity,
        forceDefaultButtons: forceDefaultToggle
            ? forceDefaultToggle.checked
            : false,
    };
}
/**
 * Get credentials form values
 */
function getCredentialsFormValues() {
    const accessKeyInput = document.getElementById("api-access-key");
    const privateKeyInput = document.getElementById("api-private-key");
    return {
        accessKey: accessKeyInput?.value || "",
        privateKey: privateKeyInput?.value || "",
    };
}
/**
 * Populate credentials form
 */
function populateCredentialsForm(accessKey = "") {
    const accessKeyInput = document.getElementById("api-access-key");
    if (accessKeyInput) {
        accessKeyInput.value = accessKey;
    }
}
